export default __webpack_public_path__ + "static/media/Snd2.11b8e817.mp3";